import { fetchWrapper } from "utils/apiFetch";
import { buildFormBody } from "./apiHelpers";

const API_BASE = "https://pro.mokshiq.in";

export const ottService = {
  // 1. Get OTT Operators (GET /get_ott_operators)
  getOperators: async () => {
    const endpoints = [
      `${API_BASE}/get_ott_operators`,
      `${API_BASE}/get_ott_operators/`,
      `${API_BASE}/api/ott/operators`,
    ];

    for (const url of endpoints) {
      try {
        const res = await fetchWrapper(url, { method: "GET" });
        const list = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : null;
        if (res && res.status !== false && list && list.length > 0) {
          return { status: true, data: list };
        }
      } catch (err) {
        // Try next route endpoint
      }
    }

    // Default operator list fallback
    return {
      status: true,
      data: [
        { name: "Sony Liv", operator_code: 17, code: "17", service: "OTT" },
        { name: "Zee 5", operator_code: 18, code: "18", service: "OTT" },
        { name: "Sun Nxt", operator_code: 19, code: "19", service: "OTT" },
        { name: "Eros Now", operator_code: 20, code: "20", service: "OTT" },
        { name: "Hungama Play", operator_code: 21, code: "21", service: "OTT" },
        { name: "Hungama Music", operator_code: 22, code: "22", service: "OTT" },
        { name: "Shemaroo", operator_code: 23, code: "23", service: "OTT" },
        { name: "Watcho OTT Pack", operator_code: 168, code: "168", service: "OTT" },
      ],
    };
  },

  // 2. Fetch OTT Plans (GET /get_ott_plans?operator_code=17)
  getPlans: async (operatorCode) => {
    const endpoints = [
      `${API_BASE}/get_ott_plans?operator_code=${operatorCode}`,
      `${API_BASE}/get_ott_plans/?operator_code=${operatorCode}`,
      `${API_BASE}/api/ott/plans?operator_code=${operatorCode}`,
    ];

    for (const url of endpoints) {
      try {
        const res = await fetchWrapper(url, { method: "GET" });
        if (res && res.status !== false) {
          return {
            status: true,
            operator: res.operator || "",
            operator_code: res.operator_code || operatorCode,
            data: Array.isArray(res.data) ? res.data : [],
          };
        }
      } catch (err) {
        // Try next route endpoint
      }
    }
    return { status: false, message: "No plans available", data: [] };
  },

  // 3. Create OTT Subscription (POST /create_ott_subscription with application/x-www-form-urlencoded)
  createSubscription: async (data) => {
    const endpoints = [
      `${API_BASE}/create_ott_subscription`,
      `${API_BASE}/create_ott_subscription/`,
      `${API_BASE}/api/ott/subscribe`,
    ];

    const bodyParams = buildFormBody({
      mobile_no: data.mobile_no,
      customer_email: data.customer_email,
      operator_code: data.operator_code,
      amount: data.amount,
      pin: data.pin,
      plan_id: data.plan_id || "",
      user_var1: data.user_var1 || "",
    });

    let lastError = null;
    for (const url of endpoints) {
      try {
        const res = await fetchWrapper(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: bodyParams,
        });

        if (res && res.status !== false) {
          return {
            status: true,
            message: res.message || "OTT Subscription activated successfully!",
            reference_num: res.reference_num || res.pid || "",
            orderid: res.orderid || "",
            optransid: res.optransid || res.opttranid || "",
            amount: res.amount || data.amount,
            operator: res.operator || "",
            wallet_balance: res.wallet_balance || null,
            commission_earned: res.commission_earned || 0,
            order_status: res.order_status || "success",
            data: res,
          };
        }
        if (res && res.status === false) {
          return {
            status: false,
            message: res.message || "Subscription request failed",
            reference_num: res.reference_num || "",
          };
        }
      } catch (err) {
        lastError = err;
      }
    }

    return { status: false, message: lastError?.message || "Transaction failed. Please try again." };
  },

  // 4. Status Check (GET /ott_status_check?partner_request_id=...)
  checkStatus: async (partnerRequestId) => {
    const url = `${API_BASE}/ott_status_check?partner_request_id=${partnerRequestId}`;
    try {
      const res = await fetchWrapper(url, { method: "GET" });
      return res || { status: false, message: "Status check failed" };
    } catch (err) {
      return { status: false, message: err.message || "Status check failed" };
    }
  },
};

export default ottService;
